// Opens/closes the "all reviews" modal on product pages. The modal's cards
// are injected separately by landing-reviews-list.js (shared with the
// homepage, so there's one real list of reviews, not two copies).
(function(){
  var btn = document.getElementById('pr-see-all-btn');
  var overlay = document.getElementById('pr-modal-overlay');
  var closeBtn = document.getElementById('pr-modal-close-btn');
  if (!btn || !overlay || !closeBtn) return;

  function open(){ overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function close(){ overlay.classList.remove('open'); document.body.style.overflow = ''; }

  btn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e){
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') close();
  });
})();
